import { memo } from "react";
import Image from "next/image";
import Logo from "@/public/icons/logo.svg";
import { Button } from "@/ui/button/button";

import styles from "../login-modal.module.css";

export const PhoneInputScreen = memo(
  ({
    phoneNumber,
    setPhoneNumber,
    onPhoneSubmit,
    type = "login",
  }: {
    phoneNumber: string;
    setPhoneNumber: (value: string) => void;
    onPhoneSubmit: () => void;
    type?: "login" | "update";
  }) => {
    const title =
      type === "login"
        ? "Укажите телефон, чтобы войти в профиль"
        : "Укажите телефон, который хотите привязать";
    const buttonText =
      type === "login" ? "Получить код для входа" : "Получить код";
    return (
      <>
        <Image src={Logo} alt="logo" width={200} height={80} priority />
        <div className={styles.phoneTitle}>{title}</div>
        <input
          className={styles.phoneInput}
          type="tel"
          value={"+7" + phoneNumber}
          placeholder="+7 (___) ___ __ __"
          maxLength={12}
          onChange={(e) => setPhoneNumber(e.target.value.slice(2))}
        />
        <div className={styles.scam}>
          Продолжая, вы соглашаетесь с условиями наших{" "}
          <a className={styles.uline} href="/docs/user-agreement" target="_blank">юридических документов</a>
        </div>
        <div className={styles.controls}>
          <Button
            type="primary"
            className={styles.loginButton}
            onClick={onPhoneSubmit}
          >
            {buttonText}
          </Button>
        </div>
      </>
    );
  },
);
